import { ZAPPOS_REBRAND_REPLACEMENT_COLORS } from 'constants/rebrand';

export const getZapposRebrandColor = ({ color, isZapposRebrand }: { color?: string; isZapposRebrand: boolean }) => {
  if (!isZapposRebrand || typeof color !== 'string') {
    return color;
  }

  try {
    const rebrandColor = ZAPPOS_REBRAND_REPLACEMENT_COLORS[color.toLowerCase() as keyof typeof ZAPPOS_REBRAND_REPLACEMENT_COLORS];

    if (rebrandColor) {
      return rebrandColor;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return color;
};
